/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_select_pickup = /** @type {(inputs: {}) => string} */ () => {
	return `Vyberte toto místo vyzvednutí`
};

const da_select_pickup = /** @type {(inputs: {}) => string} */ () => {
	return `Vælg dette afhentningssted`
};

const de_select_pickup = /** @type {(inputs: {}) => string} */ () => {
	return `Diesen Abholpunkt auswählen`
};

const en_select_pickup = /** @type {(inputs: {}) => string} */ () => {
	return `Select this pickup`
};

const es_select_pickup = /** @type {(inputs: {}) => string} */ () => {
	return `Seleccionar este punto de recogida`
};

const fr_select_pickup = /** @type {(inputs: {}) => string} */ () => {
	return `Sélectionner ce point de retrait`
};

const hu_select_pickup = /** @type {(inputs: {}) => string} */ () => {
	return `Válassza ezt a felvételi pontot`
};

const it_select_pickup = /** @type {(inputs: {}) => string} */ () => {
	return `Seleziona questo punto di ritiro`
};

const nl_select_pickup = /** @type {(inputs: {}) => string} */ () => {
	return `Selecteer dit afhaalpunt`
};

const pl_select_pickup = /** @type {(inputs: {}) => string} */ () => {
	return `Wybierz ten punkt odbioru`
};

const pt_select_pickup = /** @type {(inputs: {}) => string} */ () => {
	return `Selecionar este ponto de retirada`
};

const sv_select_pickup = /** @type {(inputs: {}) => string} */ () => {
	return `Välj detta utlämningsställe`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const select_pickup = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.select_pickup(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("select_pickup", locale)
	if (locale === "cs") return cs_select_pickup(inputs)
	if (locale === "da") return da_select_pickup(inputs)
	if (locale === "de") return de_select_pickup(inputs)
	if (locale === "en") return en_select_pickup(inputs)
	if (locale === "es") return es_select_pickup(inputs)
	if (locale === "fr") return fr_select_pickup(inputs)
	if (locale === "hu") return hu_select_pickup(inputs)
	if (locale === "it") return it_select_pickup(inputs)
	if (locale === "nl") return nl_select_pickup(inputs)
	if (locale === "pl") return pl_select_pickup(inputs)
	if (locale === "pt") return pt_select_pickup(inputs)
	return sv_select_pickup(inputs)
};